const CHECKER = {
    backgroundImage:
        'linear-gradient(45deg,#e6e2de 25%,transparent 25%),linear-gradient(-45deg,#e6e2de 25%,transparent 25%),linear-gradient(45deg,transparent 75%,#e6e2de 75%),linear-gradient(-45deg,transparent 75%,#e6e2de 75%)',
    backgroundSize: '16px 16px',
    backgroundPosition: '0 0, 0 8px, 8px -8px, -8px 0',
};

/** Live QR artwork. `previewUrl` is always a PNG data URL rendered by the engine. */
export default function QrCodePreview({ previewUrl, alt, transparent, stale }) {
    if (!previewUrl) return null;

    return (
        // No corner radius on the artwork: it would clip square-cornered frames.
        <div className="flex w-full min-w-0 items-center justify-center">
            <img
                src={previewUrl}
                alt={alt}
                style={transparent ? CHECKER : undefined}
                className={`h-auto w-full max-w-full transition-opacity duration-150 lg:max-h-[42vh] lg:w-auto ${stale ? 'opacity-60' : 'opacity-100'}`}
                draggable={false}
            />
        </div>
    );
}
